// material-ui
import { Card, CardContent, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

// ==============================|| SKELETON - TREE SUBLIST ||============================== //

const SkeletonTreeSubList = () => (
    <Card>
        <CardContent>
            <Grid container direction="column">
                <Grid item>
                    <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item xs={11}>
                            <Skeleton variant="rectangular" height={30} />
                        </Grid>
                        <Grid item xs={11}>
                            <Skeleton variant="rectangular" height={30} />
                        </Grid>
                        <Grid item xs={11}>
                            <Skeleton variant="rectangular" height={30} />
                        </Grid>
                        <Grid item xs={11}>
                            <Skeleton variant="rectangular" height={30} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </CardContent>
    </Card>
);

export default SkeletonTreeSubList;
